module.exports = function() {
  return new Worker(__webpack_public_path__ + "3d9daf3b12610642f356.worker.js");
};